import { render, staticRenderFns } from "./Codox.vue?vue&type=template&id=26c7a8c9"
import script from "./Codox.vue?vue&type=script&lang=js"
export * from "./Codox.vue?vue&type=script&lang=js"
import style0 from "./Codox.vue?vue&type=style&index=0&id=26c7a8c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports